import React from 'react';
import { CategoryResponse } from '../../../types/api/categories';
import { locale } from '../../../helpers/strings';
import { Stack, Text, IconButton } from '@primer/react'
import { ChevronRightIcon, PencilIcon, TrashIcon } from '@primer/octicons-react';

interface CategoryViewProps {
    category: CategoryResponse;
    isAllowEdit: boolean
    isForForum: boolean
    onCategoryClick: () => void;
    onEditClick: () => void;
    onDeleteClick: () => void;
}

export const CategoryView: React.FC<CategoryViewProps> = ({ category, isAllowEdit, isForForum, onCategoryClick, onEditClick, onDeleteClick }) => {
    const categoryImage = category.image?.preview ?? category.image?.file;

    return (
        <div className={`bg-white border border-border rounded-lg h-[72px] ${isAllowEdit ? 'w-auto' : 'w-full'} mx-auto flex items-center justify-center px-4 mb-4`}>
            <Stack direction="horizontal" align="center" className='w-full'>
                <div
                    style={{
                        backgroundImage: `url("${categoryImage}")`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        width: "40px",
                        height: "40px",
                        minWidth: "40px",
                        minHeight: "40px",
                        borderRadius: "50%",
                        flexShrink: 0
                    }}
                />
                <div className="flex items-center gap-4 overflow-hidden" style={{ width: 'calc(100% - 80px)' }}>
                    <div className="flex flex-col min-w-0">
                        <Stack direction="horizontal" align="center">
                            <div onClick={onCategoryClick} className="grid grid-cols-[1fr_auto] items-center h-[20px] cursor-pointer gap-2">
                                <Text
                                    className='truncate'
                                    fontSize='14'
                                    fontWeight="semibold"
                                    color="fg.default">
                                    {category.title}
                                </Text>
                                <ChevronRightIcon size={16} />
                            </div>
                        </Stack>
                        <Text fontSize={14} color="fg.muted" display="block">
                            {isForForum && <>{category.catalogsCount + ' ' + locale.subsections(category.catalogsCount)} · {category.topicsCount + ' ' + locale.topics(category.topicsCount)}</>}
                            {!isForForum && <>{category.catalogsCount + ' ' + locale.subsections(category.catalogsCount)} · {category.adsCount + ' ' + locale.ads(category.adsCount)}</>}
                        </Text>
                    </div>
                </div>
                {isAllowEdit && <Stack direction="horizontal" align="center" gap="condensed">
                    <IconButton
                        onClick={onEditClick}
                        icon={PencilIcon}
                        variant="default"
                        aria-label="Изменить" />
                    {!category.isPermanent && <IconButton
                        onClick={onDeleteClick}
                        icon={TrashIcon}
                        variant="danger"
                        aria-label="Удалить" />}
                </Stack>}
            </Stack>
        </div>

    );
};